import * as React from 'react';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  IconButton,
  Radio,
  RadioGroup,
  makeStyles,
} from '@material-ui/core';

import CloseIcon from '@material-ui/icons/Close';
import { Renewal } from 'interface/offers';
import { SyntheticEvent } from 'react';

const useStyles = makeStyles((theme) => ({
  container: {
    width: 437,
    '@media(max-width: 420px)': {
      width: 300,
    },
  },
  dialogTitleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    '& button': {
      paddingLeft: 24,
    },
  },
  dialogTitle: {
    fontWeight: 600,
    padding: '24px 24px 16px 24px',
  },
  dialogContent: {
    padding: '0 24px 0 16px',
  },
  dialogContentText: {
    fontSize: 15,
    '& p': {
      color: theme.palette.grey[600],
      fontWeight: 600,
      margin: 0,
    },
    '& label': {
      fontSize: 16,
      fontWeight: 'bold',
      margin: '16px 0',
    },
  },
  dialogActions: {
    padding: '16px 24px 24px 24px',
    '& button': {
      fontSize: 14,
      fontWeight: 600,
      padding: '9.5px 16px',
      textTransform: 'none',
      '@media(max-width: 420px)': {
        fontSize: 10,
      },
    },
  },
}));

interface IProps {
  renewals: Renewal[];
  openRenewalModal: boolean;
  offer: string;
  handleCloseCancel: () => void;
  handleChangeOffer: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleCheckIfPaymentIsPending: (event: SyntheticEvent) => void;
}

const SelectOfferModal = ({
  renewals,
  openRenewalModal,
  offer,
  handleCloseCancel,
  handleChangeOffer,
  handleCheckIfPaymentIsPending,
}: IProps) => {
  const classes = useStyles();

  const formattedRenewals = renewals.map((renewal) => {
    renewal.formattedPrice = renewal.price.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    return renewal;
  });

  return (
    <Dialog
      open={openRenewalModal}
      onClose={handleCloseCancel}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
    >
      <div className={classes.container}>
        <div className={classes.dialogTitleContainer}>
          <DialogTitle className={classes.dialogTitle}>Selecione uma oferta</DialogTitle>
          <IconButton aria-label='close' onClick={handleCloseCancel}>
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent className={classes.dialogContent}>
          <DialogContentText className={classes.dialogContentText}>
            <FormControl>
              <RadioGroup
                aria-labelledby='demo-controlled-radio-buttons-group'
                name='controlled-radio-buttons-group'
                value={offer}
                onChange={handleChangeOffer}
              >
                {formattedRenewals.map((r) => (
                  <FormControlLabel
                    key={r.id}
                    value={r.id}
                    control={<Radio checked={offer === r.id.toString()} />}
                    label={
                      <div>
                        <label>{r.title}</label>
                        <p>
                          Por <strong>{r.formattedPrice}</strong>, garanta acesso ao seu curso por mais
                          <strong> {r.validity}</strong> dias!
                        </p>
                      </div>
                    }
                  />
                ))}
              </RadioGroup>
            </FormControl>
          </DialogContentText>
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <Button onClick={handleCloseCancel}>Cancelar</Button>
          <Button variant='contained' color='primary' disabled={!offer} onClick={handleCheckIfPaymentIsPending}>
            Quero renovar!
          </Button>
        </DialogActions>
      </div>
    </Dialog>
  );
};

export default SelectOfferModal;
